<template>
  <div class="chip-status">
    <v-chip
      :color="getProps.color"
      :text-color="getProps.textColor"
      class="text-uppercase"
      label
      :disabled="disabled"
    >
      {{ getProps.label }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'Chip',
  props: {
    payload: {
      type: Object,
      default() {
        return {
          color: '',
          textColor: '',
          label: '',
        };
      },
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    getProps() {
      return this.payload;
    },
  },
};
</script>
